import Icon from '@/common/view/icons';
import Text from '@/common/view/Text';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomerDetailPageContextProvider } from '../datacontroller/CustomerDetailPageContext';
import { CustomerCampaignMessageTable } from '../view/CustomerCampaignMessageTable';
import { CustomerPurchaseHistoryTable } from '../view/CustomerPurchaseHistoryTable';
import { CustomerNameView } from '../view/CustomerNameView';
import { CustomerLeftInfoView } from '../view/CustomerLeftInfoView';
import { CustomerRightInfoView } from '../view/CustomerRightInfoView';
import { CustomerCartAndWishlistSection } from '../view/CustomerCartAndWishlistSection';
import { CustomerAIGuideSection } from '../view/CustomerAIGuideSection';
import { useProfile } from '@/auth/signin/datacontroller/AuthContext';
import { isLaroseeProfile } from '@/auth/signin/util/ProfileUtil';

const CustomerDetailPage = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const { profile } = useProfile();
  const isLarosee = isLaroseeProfile(profile);

  if (!id) {
    return null;
  }

  return (
    <CustomerDetailPageContextProvider customerId={id}>
      <div className="flex flex-col gap-5 pb-24">
        <div className="px-6 pt-10 pb-4 inline-flex items-center gap-2">
          <Icon.ArrowLeft
            className="cursor-pointer"
            width={28}
            height={28}
            onClick={() => {
              navigate(-1);
            }}
          />
          <CustomerNameView />
        </div>

        {/* AI 응대 가이드 - 라로제 전용 */}
        {isLarosee && (
          <div className="px-6">
            <CustomerAIGuideSection />
          </div>
        )}

        <div className="px-6">
          <div className="bg-typeb-gray10 rounded-lg p-5 flex flex-col gap-5">
            <div className="flex flex-col gap-3">
              <div className="w-full flex gap-3">
                <CustomerLeftInfoView />
                <CustomerRightInfoView />
              </div>
              <CustomerCartAndWishlistSection />
            </div>
          </div>
        </div>
        <div className="px-6 flex flex-col gap-3">
          <Text typo="subtitle1" color="grayBlack" className="mt-3">
            구매 이력
          </Text>
          <CustomerPurchaseHistoryTable />
        </div>

        <div className="px-6 flex flex-col gap-3">
          <Text typo="subtitle1" color="grayBlack" className="mt-3">
            캠페인 발송 이력
          </Text>
          <div className="flex flex-col gap-3">
            <CustomerCampaignMessageTable />
          </div>
        </div>
      </div>
    </CustomerDetailPageContextProvider>
  );
};

export default CustomerDetailPage;
